<div class="cx-headerTooltip_button__container">
  <a [routerLink]="[link]" routerLinkActive="router-link-active">
    <img src="{{icon}}" alt="">
    <span>{{text}}</span>
  </a>
</div>
